import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ProveedoresCreate from "./ProveedoresCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function ListadoProveedores() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [proveedores, setProveedores] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
  const [tipo, setTipo] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);
const [filtroTipo, setFiltroTipo] = useState("");

  const [idEdit, setIdEdit] = useState()
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editProveedor(event) {
    event.preventDefault();
    const URL_PROVEEDORES_EDIT = `${process.env.REACT_APP_URL_PROVEEDORES}/${idEdit}`;
    axios
      .patch(
        URL_PROVEEDORES_EDIT,
        {
          name,
          tipo,
          telefono,
          email
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Proveedor',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, tipo, telefono, email) {
        setName(name);
        setTipo(tipo);
        setTelefono(telefono);
        setEmail(email);
        setIdEdit(idEdit);
        toggle();
  }

const tiposUnicos = [...new Set(proveedores.map((p) => p.tipo))].filter(Boolean);

    const proveedoresFiltrados = proveedores
    .filter((p) => (filtroTipo ? p.tipo === filtroTipo : true))
    .sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menuProveedores ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Proveedores</h3>

                          <Row className="mb-2">
        <Col md={4}>
          <Input
            type="select"
            bsSize="sm"
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
          >
            <option value="">Tipo</option>
            {tiposUnicos.map((tipo, idx) => (
              <option key={idx} value={tipo}>
                {tipo}
              </option>
            ))}
          </Input>
        </Col>
      </Row>


                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">{t("Nombre")}</th>
                          <th className="tituloTabla">{t("Tipo")}</th>
                          <th className="tituloTabla">{t("Telefono")}</th>
                          <th className="tituloTabla">{t("Email")}</th>
                          <th className="tituloTabla">{t("Editar")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {proveedoresFiltrados
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.name}</td>
                                  <td>{a.tipo}</td>
                                  <td>{a.telefono}</td>
                                  <td>{a.email}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.name, a.tipo, a.telefono, a.email)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_PROVEEDORES
                                      }
                                    />
                              
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <ProveedoresCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Proveedor</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          
          <Label for="exampleEmail" className="mr-sm-2">
              Tipo
            </Label>
            <Input
              type="select"
              value={tipo}
              required
              onChange={(e) => {
                setTipo(e.target.value);
              }}
            >
              <option value="Agente">Agente</option>
              <option value="Agencia">Agencia</option>
              <option value="Comisionista">Comisionista</option>
              <option value="Forwarder">Forwarder</option>
              <option value="Transportista">Transportista</option>
              <option value="Servicios">Servicios</option>
              <option value="Varios">Varios</option>
            </Input>

              <Label className="mr-sm-2">{t("Telefono")}</Label>
                      <Input
                        className="col-sm-12"
                        type="text"
                        value={telefono}
                        required
                        onChange={(e) => {
                          setTelefono(e.target.value);
                        }}
                      />
                      <Label className="mr-sm-2">{t("Email")}</Label>
                      <Input
                        className="col-sm-12"
                        type="text"
                        value={email}
                        required
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editProveedor}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoProveedores;
